<script setup>
  import axios from "axios";
  import {ref} from "vue";

  const props = defineProps({
    opened: {
      type: Boolean,
      default: false
    },
    userRegistered: {
      type: Boolean,
      default: false
    },
    freeSpots: {
      type: Number,
      default: 0
    },
  });

  const userRegistered = ref(props.userRegistered);

  const register = async () => {
    // const res = await axios.post(route("networking.register"), {});
    userRegistered.value = true;
  }

  const unregister = async () => {
    // const res = await axios.delete(route("networking.unregister"), {});
    userRegistered.value = false;
  }
</script>

<template>
  <div class="flex md:justify-between md:flex-row flex-col">
    <div class="md:pr-8 pr-0">
      <p class="font-mono uppercase text-brand-green text-[16px]">Zápis na řízený networking</p>
      <div class="w-[250px] text-[14px] pt-3">
        <p>Zapište se do řízeného networkingu a my vám dáme před konferencí vědět seznam účastníků, se kterými vás můžeme propojit</p>
      </div>
    </div>
    <div class="flex">
      <a
        v-if="!userRegistered"
        @click.prevent="register"
        class="flex self-end items-center w-full justify-center px-4 py-3 mt-4 group text-[14px] hover:opacity-80 text-black font-mono bg-brand-green border border-brand-green hover:border-brand-green hover:text-brand-green hover:bg-brand-gray-700 hover:cursor-pointer group"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="mr-3 group-hover:hidden">
          <path d="M2.66699 9.33464V8.0013H7.33366V9.33464H2.66699ZM2.66699 6.66797V5.33464H10.0003V6.66797H2.66699ZM2.66699 4.0013V2.66797H10.0003V4.0013H2.66699ZM8.66699 13.3346V11.2846L12.3503 7.61797C12.4503 7.51797 12.5614 7.44575 12.6837 7.4013C12.8059 7.35686 12.9281 7.33464 13.0503 7.33464C13.1837 7.33464 13.3114 7.35964 13.4337 7.40964C13.5559 7.45964 13.667 7.53464 13.767 7.63464L14.3837 8.2513C14.4725 8.3513 14.542 8.46241 14.592 8.58464C14.642 8.70686 14.667 8.82908 14.667 8.9513C14.667 9.07352 14.6448 9.19852 14.6003 9.3263C14.5559 9.45408 14.4837 9.56797 14.3837 9.66797L10.717 13.3346H8.66699ZM9.66699 12.3346H10.3003L12.317 10.3013L12.017 9.98464L11.7003 9.68464L9.66699 11.7013V12.3346ZM12.017 9.98464L11.7003 9.68464L12.317 10.3013L12.017 9.98464Z" fill="black"/>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="mr-3 group-hover:block hidden">
          <path d="M2.66699 9.33464V8.0013H7.33366V9.33464H2.66699ZM2.66699 6.66797V5.33464H10.0003V6.66797H2.66699ZM2.66699 4.0013V2.66797H10.0003V4.0013H2.66699ZM8.66699 13.3346V11.2846L12.3503 7.61797C12.4503 7.51797 12.5614 7.44575 12.6837 7.4013C12.8059 7.35686 12.9281 7.33464 13.0503 7.33464C13.1837 7.33464 13.3114 7.35964 13.4337 7.40964C13.5559 7.45964 13.667 7.53464 13.767 7.63464L14.3837 8.2513C14.4725 8.3513 14.542 8.46241 14.592 8.58464C14.642 8.70686 14.667 8.82908 14.667 8.9513C14.667 9.07352 14.6448 9.19852 14.6003 9.3263C14.5559 9.45408 14.4837 9.56797 14.3837 9.66797L10.717 13.3346H8.66699ZM9.66699 12.3346H10.3003L12.317 10.3013L12.017 9.98464L11.7003 9.68464L9.66699 11.7013V12.3346ZM12.017 9.98464L11.7003 9.68464L12.317 10.3013L12.017 9.98464Z" fill="#9EFC4E"/>
        </svg>
        Zapsat se na řízený networking
      </a>
      <a
        v-else
        @click.prevent="unregister"
        class="flex self-end items-center w-full justify-center px-4 py-3 mt-4 group text-[14px] hover:opacity-80 text-brand-green font-mono bg-brand-gray-900 border border-brand-green hover:border-brand-green hover:text-brand-green hover:bg-brand-gray-700 hover:cursor-pointer group"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none" class="mr-3">
          <path d="M3.83333 14C3.46667 14 3.15278 13.8694 2.89167 13.6083C2.63056 13.3472 2.5 13.0333 2.5 12.6667V3.33333C2.5 2.96667 2.63056 2.65278 2.89167 2.39167C3.15278 2.13056 3.46667 2 3.83333 2H8.5V3.33333H3.83333V12.6667H8.5V14H3.83333ZM11.1667 11.3333L10.25 10.3667L11.95 8.66667H6.5V7.33333H11.95L10.25 5.63333L11.1667 4.66667L14.5 8L11.1667 11.3333Z" fill="#9EFC4E"/>
        </svg>
        Odhlásit se z networkingu
      </a>
    </div>
  </div>
  <div class="text-[14px] mt-4 text-brand-green font-mono">
    <span v-if="!userRegistered">Zbývá {{props.freeSpots}} volných míst</span>
    <span v-else>Jste zapsán!</span>
  </div>
</template>

<style scoped>

</style>
